export enum CodeTypeEnum {
  UNIVERSAL = 'UNIVERSAL',
  UNIQE = 'UNIQUE',
}

export const CodeTypeValue = {
  [CodeTypeEnum.UNIVERSAL]: 'Universal Code ใช้ได้หลายคน',
  [CodeTypeEnum.UNIQE]: 'Unique Code ใช้เฉพาะบุคคล',
}
